import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
//import Habitaciones from './components/Habitaciones';
import Reservas from "./components/Reservas";
import Informes from "./components/Informes";
import Login from "./components/Login";
import ReservasVisualizador from "./components/AbmReservas";
import CreateUser from "./components/CreateUser";
import NavBarAdmin from "./navBar/NavBarAdmin";
import NavBarUser from "./navBar/NavBarUser";
import NavBarUserInfo from "./navBar/NavBarUserInfo";
import EditarReserva from "./components/EditarReserva";
import ReservasUsuario from "./components/ReservasUsuario";
import InformeTipoMiembro from "./components/InformeTipoMiembro";
import BuscarMiembrosPorHabitacion from "./components/BuscarMiembroPorHabitacion";
import { AuthProvider, useAuth } from "./context/AuthContext";
import TopBar from "./navBar/TopBar";
import InformesFederaciones from "./components/InformesFederaciones";
import Dashboard from "./components/Dashboard";

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<ProtectedRoutes />} />
      </Routes>
    </AuthProvider>
  );
}

// Componente para decidir a qué rutas dirigir según el rol
function ProtectedRoutes() {
  const { user, authToken } = useAuth();

  if (!authToken) {
    return <Navigate to="/login" />; // Redirigir a login si no hay token
  }

  if (!user || !user.tipoRol) {
    return <Navigate to="/login" />; // Asegurarse de que `user` tiene `tipoRol`
  }

  // Redirigir según el rol del usuario
  if (user.tipoRol === "administrador") {
    return <AdminRoutes />; // Rutas del administrador
  } else if (user.tipoRol === "solicitar_reservas") {
    return <UserRoutes />;
  } else if (user.tipoRol === "consultar_informes") {
    return <UserinfoRoutes />; // Rutas para usuarios que ven solo informes regulares
  } else {
    return <Navigate to="/" />; // Redirigir a la página por defecto si el rol no coincide
  }
}

// Layout para administradores
function AdminLayout() {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Barra superior */}
      <TopBar />
      {/* Contenedor principal */}
      <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
        {/* Barra lateral */}
        <NavBarAdmin />
        {/* Contenido principal */}
        <div style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

// Layout para usuarios regulares
function UserLayout() {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Barra superior */}
      <TopBar />
      {/* Contenedor principal */}
      <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
        {/* Barra lateral */}
        <NavBarUser />
        {/* Contenido principal */}
        <div style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

function UserInfoLayout() {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Barra superior */}
      <TopBar />
      {/* Contenedor principal */}
      <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
        {/* Barra lateral */}
        <NavBarUserInfo />
        {/* Contenido principal */}
        <div style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

// Rutas específicas para administradores
function AdminRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="reservas" element={<Reservas />} />
        <Route path="informes" element={<Informes />} />
        <Route path="reservas_usuario" element={<ReservasUsuario />} />
        <Route path="crear_usuarios" element={<CreateUser />} />
        <Route path="editar_reserva/:id" element={<EditarReserva />} />
        <Route
          path="miembros_por_habitacion"
          element={<BuscarMiembrosPorHabitacion />}
        />
        <Route
          path="informes_federaciones"
          element={<InformesFederaciones />}
        />
        <Route
          path="informes_por_tipo_miembro"
          element={<InformeTipoMiembro />}
        />
        <Route index element={<Navigate to="/reservas" />} />{" "}
        {/* Ruta por defecto */}
        <Route path="reservasvisualizador" element={<ReservasVisualizador />} />
      </Route>
    </Routes>
  );
}

// Rutas específicas para usuarios regulares
function UserRoutes() {
  return (
    <Routes>
      <Route path="/" element={<UserLayout />}>
        <Route path="reservas" element={<Reservas />} />
        <Route path="reservas_usuario" element={<ReservasUsuario />} />
        <Route index element={<Navigate to="/reservas" />} />{" "}
        {/* Ruta por defecto */}
      </Route>
    </Routes>
  );
}

function UserinfoRoutes() {
  return (
    <Routes>
      <Route path="/" element={<UserInfoLayout />}>
        <Route path="informes" element={<Informes />} />
        <Route index element={<Navigate to="/informes" />} />{" "}
        {/* Ruta por defecto */}
      </Route>
    </Routes>
  );
}

export default App;
